/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_No_Saved_FiltersInputs */

const en_common_no_saved_filters = /** @type {(inputs: Common_No_Saved_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No saved filters found`)
};

/**
* | output |
* | --- |
* | "No saved filters found" |
*
* @param {Common_No_Saved_FiltersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_no_saved_filters = /** @type {((inputs?: Common_No_Saved_FiltersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_No_Saved_FiltersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_no_saved_filters(inputs)
});